import React from "react";
import { Outlet } from "react-router-dom";

const CargoSearchList: React.FC = () => {
  return <Outlet />;
};

export default CargoSearchList;